document.addEventListener('DOMContentLoaded', function() {
  scrollObserve('.c-fadein');
});

function scrollObserve(val) {
  const els = document.querySelectorAll(val);
  const cb = function(entries, observer) {
      entries.forEach(entry => {
          if(entry.isIntersecting) {
              entry.target.classList.add('is-active');
              observer.unobserve(entry.target); //1回で処理を停止
          } else {
              entry.target.classList.remove('is-active');
          }
      });
  }

  const io = new IntersectionObserver(cb);
  els.forEach(el => io.observe(el));
}

